window.addEventListener('DOMContentLoaded', function() {
    function toggleHeaderClassOnScroll() {
        const header = document.querySelector('#header');

        if (window.scrollY > 0) {
            header.classList.add('scrolled');
        }

        window.addEventListener('scroll', function() {
            if (window.scrollY > 0) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }

            if (window.scrollY > header.offsetHeight) {
                header.classList.add('scrolled_far');
            } else {
                header.classList.remove('scrolled_far');
            }
        });
    }

    toggleHeaderClassOnScroll();
});
